module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-4"
  }, [_vm._c('div', {
    staticClass: "article text-center"
  }, [_vm._c('div', {
    staticClass: "image",
    style: (_vm.image ? 'background-image:url(' + _vm.image + ');' : '')
  }, [_vm._c('router-link', {
    attrs: {
      "to": {
        name: 'blog-article',
        params: {
          id: _vm.article.id
        }
      }
    }
  })], 1), _vm._v(" "), _vm._c('div', {
    staticClass: "article-content",
    class: _vm.image ? '' : 'no-image'
  }, [_vm._c('h2', [_vm._c('router-link', {
    attrs: {
      "to": {
        name: 'blog-article',
        params: {
          id: _vm.article.id
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.article.title))])], 1), _vm._v(" "), _vm._c('p', {
    staticClass: "large-text"
  }, [_vm._v(_vm._s(_vm.content))])]), _vm._v(" "), _vm._c('router-link', {
    staticClass: "btn-pub btn-pub-border-primary fixed-width xs-full-width",
    attrs: {
      "to": {
        name: 'blog-article',
        params: {
          id: _vm.article.id
        }
      }
    }
  }, [_vm._v("\n      Read More\n    ")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-cb5bd67c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/blog/BlogListArticle.vue
// module id = 716
// module chunks = 1